export default function () {
    if (herald_js_settings.single_sticky_bar) {
        var herald_footer_offset = $('.herald-site-footer').offset().top - $(window).height();

        /* Single Sticky Bar Mobile Navigation */
        if ($('body').hasClass('single') && obj.find('.herald-single-sticky').length) {
            var herald_sticky_share_elements = obj.find('.herald-single-sticky').clone(true, true);
            obj.append('<div class="herald-single-sticky herald-single-mobile-sticky hidden-lg hidden-md">' + herald_sticky_share_elements.html() + '</div>');
        }
        $(window).scroll(function () {
            var top = $(window).scrollTop();
            if (top >= obj.offset().top + 600 && top < herald_footer_offset) {
                obj.addClass("herald-sticky-single-visible");
            } else {
                obj.removeClass("herald-sticky-single-visible");
            }
        });
    }
}
